export default __webpack_public_path__ + "static/img-platform-explain-41d2d6609f5bfbd9721c76ff527014d3.webp";